module.exports = __webpack_public_path__ + "static/img/rolling_pallet.0c7a80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rolling_pallet.jpg
// module id = qgCy
// module chunks = 1